import { timeline } from 'wix-animations';
import wixWindow from 'wix-window';
import { fireBIEvent } from 'public/bi-events.js';
import { url as PageURL } from 'wix-location';

$w.onReady(function () {
    if (wixWindow.formFactor === "Desktop") {
        $w("#FAQRepeater").forEachItem(($item, itemData, index) => {
            $item("#FAQButton").onClick(() => {
                if (!$item("#FAQTextBox").isVisible) {
                    timeline().add($item("#FAQVector"), {
                        "rotate": 135,
                        "duration": 300,
                        "easing": "easeOutQuad"
                    }).play();

                    $item("#FAQTextBox").expand();
                } else {
                    timeline().add($item("#FAQVector"), {
                        "rotate": -90,
                        "duration": 300,
                        "easing": "easeOutQuad"
                    }).play();

                    $item("#FAQTextBox").collapse();
                }
            })
        });
    }

});

let fadeOptions = {
    "duration": 500, //time in ms
}

export function box5_viewportEnter(event) {
    $w('#columnImage1').show("fade", fadeOptions);
    $w('#columnImage2').hide("fade", fadeOptions);
}

export function box6_viewportEnter(event) {
    $w('#columnImage1').hide("fade", fadeOptions);
}

export function box7_viewportEnter(event) {
    $w('#columnImage2').show("fade", fadeOptions);
}

export function box8_viewportEnter(event) {
    $w('#columnImage2').hide("fade", fadeOptions);
}

export function fold1btn_click() {
    const biFields = {
        button_name: 'lets talk - fold 1',
        topic: 'enterprise main LP',
        url: PageURL,
        is_valid: true,
        additional_info: 'fold 1',
        targetUrl: 'https://www.wix.com/wix-platform/enterprise-lp/form'
    }
    fireBIEvent(19, 703, biFields);
}

export function fold2btn_click() {
    const biFields = {
        button_name: 'lets talk - fold 2',
        topic: 'enterprise main LP',
        url: PageURL,
        additional_info: 'fold 2',
        is_valid: true,
        targetUrl: 'https://www.wix.com/wix-platform/enterprise-lp/form'
    }
    fireBIEvent(19, 703, biFields);
}

export function fold3btn_click() {
    const biFields = {
        button_name: 'lets talk - fold 3',
        topic: 'enterprise main LP',
        url: PageURL,
        additional_info: 'fold 3',
        is_valid: true,
        targetUrl: 'https://www.wix.com/wix-platform/enterprise-lp/form'
    }
    fireBIEvent(19, 703, biFields);
}

export function fold4btn_click() {
    const biFields = {
        button_name: 'book a call - fold 6',
        topic: 'enterprise main LP',
        url: PageURL,
        additional_info: 'fold 6',
        is_valid: true,
        targetUrl: 'https://www.wix.com/wix-platform/enterprise-lp/form'
    }
    fireBIEvent(19, 703, biFields);
}

export function text45_viewportEnter() {
    const biFields = {
        lp_name: 'enterprise main lp',
    }
    fireBIEvent(19, 125102, biFields);
}